/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconPlanet4 = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 24 24"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 24px;
      `}
      {...props}
    >
      <g
        fill={fill}
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={weight === "normal" ? 1.5 : 1}
      >
        <path d="M19.471.765l-1.061 1.06M19.471.765l-1.061 1.06M3.561 16.675L2.5 17.735M3.561 16.675L2.5 17.735M10.985 19.75v3M4.985 22.75h12M10.985 1.75a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15z" />
        <path d="M18.41 1.825c4.101 4.1 4.101 10.749 0 14.849s-10.749 4.101-14.849 0" />
      </g>
    </svg>
  ),
);
